import { render, staticRenderFns } from "./report-interaction-tab.vue?vue&type=template&id=4bf430a2&scoped=true"
import script from "./report-interaction-tab.vue?vue&type=script&lang=js"
export * from "./report-interaction-tab.vue?vue&type=script&lang=js"
import style0 from "./report-interaction-tab.vue?vue&type=style&index=0&id=4bf430a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf430a2",
  null
  
)

export default component.exports